import React from 'react';
import Icon from '../../../components/AppIcon';

const BreadcrumbNav = ({ path, onNavigate, activeFolder }) => {
  const pathSegments = path?.split('/')?.filter(Boolean);

  return (
    <nav className="flex items-center gap-2 text-sm flex-wrap" aria-label="Breadcrumb navigation">
      <button
        onClick={() => onNavigate('/')}
        className="flex items-center gap-1 px-2 py-1 rounded-md hover:bg-muted transition-colors duration-150 text-muted-foreground hover:text-foreground"
      >
        <Icon name="Home" size={16} />
        <span>Root</span>
      </button>
      <div className="flex items-center gap-2">
        <Icon name="ChevronRight" size={16} className="text-muted-foreground" />
        {activeFolder?.folder_path ? (
          <div className="flex items-center gap-1.5 px-2 py-1 bg-primary/10 rounded-md border border-primary/20">
            <Icon name="Folder" size={14} className="text-primary" />
            <span className="text-xs font-medium text-primary truncate max-w-[200px]" title={activeFolder?.folder_path}>
              {activeFolder?.folder_path}
            </span>
          </div>
        ) : (
          <span className="text-xs text-muted-foreground italic px-2 py-1">
            No folder path available
          </span>
        )}
      </div>
      {pathSegments?.map((segment, index) => {
        const segmentPath = '/' + pathSegments?.slice(0, index + 1)?.join('/');
        const isLast = index === pathSegments?.length - 1;
        return (
          <React.Fragment key={segmentPath}>
            <Icon name="ChevronRight" size={16} className="text-muted-foreground" />
            <button
              onClick={() => onNavigate(segmentPath)}
              className={`px-2 py-1 rounded-md transition-colors duration-150 ${
                isLast
                  ? 'text-foreground font-medium'
                  : 'text-muted-foreground hover:text-foreground hover:bg-muted'
              }`}
            >
              {segment}
            </button>
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default BreadcrumbNav;